import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { formatDeShort } from "@/lib/date";

const WING = { animate: { scaleY: [1, 0.15, 1] }, transition: { duration: 0.12, repeat: Infinity, ease: "easeInOut" } };

export function HummingbirdIcon({ size = 28, flapping = true, className = "", testId }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} data-testid={testId} aria-label="Kolibri">
      <defs>
        <linearGradient id="hb-body" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#14b8a6" /><stop offset="1" stopColor="#0a788c" /></linearGradient>
        <linearGradient id="hb-wing" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#a7f3d0" /><stop offset="1" stopColor="#10b981" /></linearGradient>
      </defs>
      <path d="M14 40 L2 50 L8 40 L1 41 Z" fill="#0f766e" />
      <ellipse cx="26" cy="38" rx="15" ry="7" fill="url(#hb-body)" transform="rotate(-18 26 38)" />
      <circle cx="41" cy="30" r="6.5" fill="url(#hb-body)" />
      <path d="M38 34 Q41 38 45 34 Z" fill="#db2777" />
      <path d="M46.5 29 L63 25.5 L46.5 31.2 Z" fill="#1f2937" />
      <circle cx="43" cy="28.5" r="1.3" fill="#0f172a" />
      <motion.g style={{ originX: "28px", originY: "34px" }} {...(flapping ? WING : {})}>
        <path d="M28 34 Q20 10 34 4 Q36 20 30 34 Z" fill="url(#hb-wing)" opacity="0.9" />
      </motion.g>
    </svg>
  );
}

export function HummingbirdCelebration({ item, onClose }) {
  return (
    <AnimatePresence>
      {item && (
        <motion.div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-6" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={onClose} data-testid="handover-celebration">
          <motion.div className="pointer-events-none absolute z-20" initial={{ x: "-55vw", y: 120 }} animate={{ x: ["-55vw", "-10vw", "8vw", "55vw"], y: [120, -60, 20, -160] }} transition={{ duration: 4.2, ease: "easeInOut" }}>
            <HummingbirdIcon size={140} />
          </motion.div>
          <motion.div className="relative z-10 bg-white border border-emerald-200 max-w-md w-full p-8 text-center shadow-xl" initial={{ y: 30, scale: 0.95 }} animate={{ y: 0, scale: 1 }} transition={{ delay: 0.6, type: "spring", stiffness: 180 }} onClick={(e) => e.stopPropagation()}>
            <motion.div className="mx-auto w-fit" animate={{ y: [0, -6, 0] }} transition={{ duration: 1.6, repeat: Infinity }}><HummingbirdIcon size={72} /></motion.div>
            <div className="text-xs font-bold uppercase tracking-overline text-emerald-700 mt-3">Beija-Flor · Pünktlich übergeben</div>
            <h2 className="font-heading text-3xl font-light tracking-tighter text-slate-900 mt-2">Geschafft, rechtzeitig!</h2>
            <p className="text-sm text-slate-600 mt-3 leading-relaxed" data-testid="handover-celebration-text">
              Du hast deinen Teil bei <b>{item.client_name}</b> am {formatDeShort(item.handed_over_on)} abgeschlossen – vor der Frist {formatDeShort(item.deadline)} – und pünktlich an <b>{item.next_name}</b> übergeben.
            </p>
            <button onClick={onClose} className="mt-6 px-5 py-2.5 bg-emerald-600 hover:bg-emerald-700 text-white text-sm transition-colors" data-testid="handover-celebration-close">Weiter so!</button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
